.wrap {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin: 10px 0;
  user-select: none;
  position: relative;

  :global .react-datetime-picker {
    min-width: 225px;

    &__wrapper {
      min-width: 225px;
      border: 1px solid #aaa;
      border-radius: 4px;  
      background: white;
      padding: 6px 5px;
    }

    &__inputGroup {
      text-align: right;
    }

    &__inputGroup__amPm {
      appearance: none;
      padding-right: 10px;
      outline: none;
    }

    &__calendar-button, &__clear-button {
      display: none;
    }

    input:active, input:focus {
      outline: 1px solid transparent;
    }
  }

  // select box
  :global [class$=-control] {
    border: 1px solid #aaa !important;
    box-shadow: none !important;
  }

  :global [class$=-singleValue] {
    height: 23px;
    font-weight: 500;
    top: calc(50% + 2px);
    text-transform: capitalize;
  }

  :global [class$=indicatorSeparator] {
    display: none;
  }

  :global [class$=indicatorContainer] {
    color: hsl(0,0%,80%) !important;
  }

  :global [class$=-menu] {
    text-transform: capitalize;
  }
}

.x {
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  display: none;
  background: white;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  text-align: center;
  border: 1px solid gray;
  font-size: 21px;
  cursor: pointer;
  color: #999;
  line-height: 0.95;

  .wrap:hover & {
    display: block;
  }

  &:hover {
    color: black;
  }
}

.custom {
  display: none;
  min-width: 225px;
  border: 1px solid #aaa;
  border-radius: 4px;
  background: white;
  padding: 8px 6px 7px 10px;
  margin: 9px 0 0 18px;
  outline: none;

  .wrap:hover & {
    display: block;
  }
}